import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const SoundOffFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="soundOffFilled" ref={ref} {...props}>
    <path d="M11.34,7v3.55a.76.76,0,0,1-.23.53l-3.69,3.6a.77.77,0,0,1-.52.21.82.82,0,0,1-.45-.14l-.09-.07H4.56A.75.75,0,0,1,3.81,14V10a.75.75,0,0,1,.75-.75H6.27l3.88-2.83A.75.75,0,0,1,11.34,7Zm5.48-.94a.76.76,0,0,0-.16-1,8.56,8.56,0,0,0-1.36-.81.75.75,0,1,0-.65,1.35,7.06,7.06,0,0,1,1.12.67.74.74,0,0,0,.44.14A.76.76,0,0,0,16.82,6.1Zm3.71-1a.75.75,0,0,0-1.06,0L5.85,18.71a.75.75,0,0,0,0,1.06.74.74,0,0,0,.53.22.73.73,0,0,0,.53-.22l2.65-2.65.59.43a.77.77,0,0,0,.44.14.84.84,0,0,0,.34-.08.76.76,0,0,0,.41-.67v-1.6l4.08-4.08a3.54,3.54,0,0,1,.07.73v0a3.91,3.91,0,0,1-2,3.43.74.74,0,0,0-.3,1,.76.76,0,0,0,.66.39.77.77,0,0,0,.36-.09A5.39,5.39,0,0,0,17,12v0a5.26,5.26,0,0,0-.37-1.93l1.29-1.29A7,7,0,0,1,18.69,12a7.14,7.14,0,0,1-4,6.41A.75.75,0,0,0,15,19.84a.72.72,0,0,0,.32-.08,8.64,8.64,0,0,0,4.88-7.61.76.76,0,0,0,0-.15c0-.05,0-.1,0-.15A8.51,8.51,0,0,0,19,7.66l1.51-1.51A.75.75,0,0,0,20.53,5.09Z" />
  </Icon>
)) as IconWithRender;

SoundOffFilledIcon.displayName = 'SoundOffFilledIcon';
SoundOffFilledIcon.renderIcon = (props) => <SoundOffFilledIcon {...props} />;
export default SoundOffFilledIcon;
